__webpack_require__.p = "/widgets/upload-artwork/2.1.80.fa0ebbb/";